import OrderSummarize from './order-summarize';

export default OrderSummarize;
